export const DEFAULT_LOCALE = 'en-GB';
export const DEFAULT_CURRENCY_CODE = 'GBP';
export const DEFAULT_GROUP_SEPRATOR = ' ';
export const DEFAULT_DECIMAL_SEPARATOR = ',';
export const DEFAULT_DECIMAL_POINTS = 2;
